// extracted by mini-css-extract-plugin
export default {"card":"styles_card__s-GJl","name":"styles_name__N8ZsH","summary-info":"styles_summary-info__OfzLx"};